import { Flex, Skeleton } from '@iheartjane/reefer';

import styles from './productsSkeleton.module.css';

export function ProductsSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className={styles['productGridContainer']}>
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} animate>
          <Skeleton.Bone className={styles['image']} />
          <Flex gap={16} flexDirection="column">
            <Skeleton.Bone className={styles['productText']} />
            <Skeleton.Bone className={styles['productText']} />
            <Skeleton.Bone className={styles['productText']} />

            <Skeleton.Bone className={styles['addToCart']} />
          </Flex>
        </Skeleton>
      ))}
    </div>
  );
}
